// session-modal.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SessionModalService {
  private _visible$ = new BehaviorSubject<boolean>(false);
  public visible$ = this._visible$.asObservable();

  private _message$ = new BehaviorSubject<string | null>(null);
  public message$ = this._message$.asObservable();

  // nuevo: stream que indica si el modal es 'fatal' (causar logout) o solo informativo
  private _fatal$ = new BehaviorSubject<boolean>(false);
  public fatal$ = this._fatal$.asObservable();

  private timeoutHandle: any = null;

  constructor(private auth: AuthService) {}

  /**
   * Mostrar modal
   * @param message Mensaje a mostrar
   * @param fatal Si true, al aceptar se hará logout; si false, solo se cerrará el modal
   */
  show(message: string, fatal: boolean = false) {
    this._message$.next(message);
    this._fatal$.next(Boolean(fatal));
    this._visible$.next(true);
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
  }

  /**
   * Ocultar modal. Si redirect === true, delega en AuthService para limpiar y redirigir.
   */
  hide(redirect: boolean = false) {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
    this._visible$.next(false);
    this._message$.next(null);
    this._fatal$.next(false);

    if (redirect) {
      // delegar limpieza ordenada al AuthService si se pasa redirect explícito
      this.auth.logout(true);
    }
  }
}
